// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1Vz7S","colMaxWidth":"Table_colMaxWidth__86h6U"};